// import { Box, Button, Paper, Stack, Typography } from '@mui/material';
// import React, { useEffect, useRef } from 'react';

// const VideoReStream = ({ url, streamStatus, handleSteamStatus, sx, ...others }) => {


//   const imgRef = useRef(null);

//   // Function to start the stream
//   const startStream = () => {
//     handleSteamStatus('loading')

//     if (imgRef.current && url) {
//       imgRef.current.src = url; // Append a timestamp to avoid caching
//     }
//   };

//   useEffect(() => {
//     // setIsStreaming(false);
//     startStream(); // Initialize the stream on component mount

//     return () => {
//       if (imgRef.current) {
//         imgRef.current.src = ''; // Clear the src on component unmount to stop streaming
//       }
//     };
//   }, [url]);

//   // console.log('streamStatus', streamStatus)

//   return (
//     <Stack direction="row"
//       spacing={2}
//       sx={{
//         justifyContent: "center",
//         alignItems: "center",
//         backgroundColor: streamStatus === 'playing' ? 'none' : '#ededed',
//         ...sx
//       }}>
//       <Box>
//         {(!streamStatus || !url) ? (
//           <Typography variant="h4" color='gray'>Preview</Typography>

//         ) : streamStatus === 'loading' ? (
//           <Typography variant="h4" color='gray'>Loading...</Typography>
//         ) : streamStatus === 'error' && (
//           <>
//             <Typography variant="h4" color='gray'>Something went wrong.</Typography>
//             <Button onClick={startStream}>Try again</Button>
//           </>
//         )}
//       </Box>
     
//       <Paper
//         ref={imgRef}
//         alt="Streaming video"
//         onError={() => handleSteamStatus('error')}
//         onLoad={() => handleSteamStatus('playing')} // Set streaming as true when loaded
//         sx={{ display: streamStatus === 'playing' ? 'block' : 'none' }} // Hide until streaming 
//         {...others}
//         component='img'
//       />

//     </Stack>
//   );
// };

// export default VideoReStream;
import { Box, Paper, Stack, Typography } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";

const MAX_STORE_FRAMES = 6

const VideoReStream = ({ url, streamStatus, handleSteamStatus, capturedImages, setCapturedImages, sx, captureInterval = 1000, ...others }) => {
  const imgRef = useRef(null);
  const canvasRef = useRef(null);
  
  const captureIntervalRef = useRef(null);

  // Start streaming
  const startStream = () => {
    handleSteamStatus("loading");
    if (imgRef.current && url) {
      imgRef.current.src = url;
    }
  };

  useEffect(() => {
    startStream();
    return () => {
      if (imgRef.current) imgRef.current.src = "";
    };
  }, [url]);

  // Debug: log whenever capturedImages changes
  // useEffect(() => {
  //   if (capturedImages && capturedImages.length > 0) {
  //     // Only log when a new image is added
  //     //console.debug("[VideoReStream] New images captured. Total:", capturedImages.length, "Captured Images:", capturedImages);
  //   }
  // }, [capturedImages]);

  const captureImage = () => {

    if (capturedImages.length >= 7) {
      if (captureIntervalRef.current) clearInterval(captureIntervalRef.current);
      return;
    }

    const img = imgRef.current;
    const canvas = canvasRef.current;
    
    if (img && canvas) {
        const ctx = canvas.getContext("2d");
        canvas.width = img.width;
        canvas.height = img.height;
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

        // Convert canvas to Blob (image/png format)
        canvas.toBlob((blob) => {
            if (blob) {
                //const file = new File([blob], `img${capturedImages.length + 1}.png`, { type: "image/png" });                
                // Debug: just created a file from stream
                //console.debug("[VideoReStream] Stream frame converted to File:", file);

                // Update images array with actual File objects
                setCapturedImages((prevImages) => {
                  if (prevImages.length >= 7) return prevImages; 

                    const file = new File([blob], `img${prevImages.length + 1}.png`, { type: "image/png" }); 

                    const startIndex = prevImages.length - MAX_STORE_FRAMES < 0 ? 0 : prevImages.length - MAX_STORE_FRAMES;
                    const updatedImages = [...prevImages, file];
                    //const storedImages = updatedImages.slice(startIndex, updatedImages.length);
                    const storedImages = updatedImages.slice(startIndex);
                    // Debug: show new storedImages when a new one is about to be set
                    //console.debug("[VideoReStream] Updating captured images list, now length:", storedImages.length, storedImages);
                    return storedImages;
                });
            }
        }, "image/png");
    }
};

  // Start automatic image capturing when video is playing
  useEffect(() => {
    if (streamStatus === "playing" && capturedImages.length < 7) {
      captureIntervalRef.current = setInterval(() => {
        captureImage();
      }, captureInterval);
    } else {
      clearInterval(captureIntervalRef.current);
    }

    return () => clearInterval(captureIntervalRef.current);
    
  }, [streamStatus, capturedImages.length]); // Dependency includes capturedImages to stop at 4

  return (
    <Stack direction="column" spacing={2} sx={{ alignItems: "center", ...sx }}>
      <Box>
        {(!streamStatus || !url) ? (
          <Typography variant="h4" color="gray">Preview</Typography>
        ) : streamStatus === "loading" ? (
          <Typography variant="h4" color="gray">Loading...</Typography>
        ) : streamStatus === "error" && (
          <Typography variant="h4" color="gray">Something went wrong.</Typography>
        )}
      </Box>

      {/* Streaming Image */}
      <Paper
        crossOrigin="anonymous"
        ref={imgRef}
        alt="Streaming video"
        onError={() => handleSteamStatus("error")}
        onLoad={() => handleSteamStatus("playing")}
        sx={{ display: streamStatus === "playing" ? "block" : "none" }}
        component="img"
        {...others}
      />

      {/* Hidden Canvas for Capturing Frames */}
      <canvas ref={canvasRef} style={{ display: "none" }} />
    </Stack>
  );
};

export default VideoReStream;
